const paginate = ({ types, mapActionToKey }) => {
  if (!Array.isArray(types) || types.length !== 4) {
    throw new Error("Expected types to be an array of four elements.")
  }
  if (!types.every(t => typeof t === "string")) {
    throw new Error("Expected types to be strings.")
  }
  if (typeof mapActionToKey !== "function") {
    throw new Error("Expected mapActionToKey to be a function.")
  }

  const [requestType, successType, failureType, clearType] = types

  const initialPaginationState = {
    isFetching: false,
    pageCount: 0,
    results: []
  }

  const updatePagination = (state = initialPaginationState, action) => {
    switch (action.type) {
    case requestType:
      return {
        ...state,
        isFetching: true
      }
    case successType:
      return {
        ...state,
        isFetching: false,
        results: action.payload.hits
      }
    case failureType:
      return {
        ...state,
        isFetching: false
      }
    default:
      return state
    }
  }

  return (state = { 1: initialPaginationState }, action) => {
    // Update pagination by key
    if (action.type === requestType || action.type === successType || action.type === failureType) {
      const key = mapActionToKey(action)
      if (typeof key !== "string") {
        throw new Error("Expected key to be a string.")
      }
      return {
        ...state,
        [key]: updatePagination(state[key], action)
      }
    } else if (action.type === clearType) {
      return {
        1: initialPaginationState
      }
    }
    return state
  }
}

export default paginate



// WEBPACK FOOTER //
// ./src/store/reducers/paginate.js